import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";


const products = [
  {
    id: 1,
    name: "School Desk",
    price: "₹5000",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914",
  },
  {
    id: 2,
    name: "Office Chair",
    price: "₹3000",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7",
  },
  {
    id: 3,
    name: "Laptop",
    price: "₹45000",
    image: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8",
  },
  {
    id: 4,
    name: "Microscope",
    price: "₹15000",
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
  },
];

const FeaturedProducts = () => {
  const navigate = useNavigate();

  return (
    <Box p={5}>
      <Typography variant="h4" mb={4} fontWeight="bold">
        Featured Products
      </Typography>

      <Grid container spacing={3}>
        {products.map((product) => (
          <Grid item xs={12} sm={6} md={3} key={product.id}>
            <motion.div whileHover={{ y: -10 }}>
              <Card
                sx={{ cursor: "pointer" }}
                onClick={() => navigate(`/product/${product.id}`)}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={product.image}
                />

                <CardContent>
                  <Typography variant="h6">{product.name}</Typography>

                  <Typography color="text.secondary">
                    {product.price}
                  </Typography>

                  <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={(e) => {
                      e.stopPropagation(); // 🔴 IMPORTANT
                      console.log("Added to cart:", product.name);
                    }}
                  >
                    Add to Cart
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturedProducts;